"use client";

import Link from "next/link";

import { useSession } from "@/lib/auth-client";

import { DEMO_BOOKING_URL } from "./nav-links";

/**
 * Hero CTA for the researcher marketing page. Researchers do not self-serve
 * onto the platform, so a signed-out visitor books a call instead of signing
 * up. A signed-in one already has an organization and belongs in the app.
 */
export function ResearcherHeroCta({ className }: { className: string }) {
  const { data: session, isPending } = useSession();

  // Until the session resolves, keep the signed-out label: it is correct for
  // most visitors and booking a call is safe for a signed-in one too.
  const isSignedIn = !isPending && Boolean(session);

  if (isSignedIn) {
    return (
      <Link href="/" className={className} prefetch={false}>
        Go to your dashboard
      </Link>
    );
  }

  return (
    <Link
      href={DEMO_BOOKING_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      prefetch={false}
    >
      Book a call
    </Link>
  );
}
